// The window a patient asked for, read from the whole thread.
//
// It was read from their very latest message only. The common shape of a
// conversation is "I'm free the week of Oct 19" → the office replies →
// "Yes!" — and after that "Yes!" the window was gone: the panel opened on
// the soonest day again and the offer warning could not fire. The window
// is the most recent patient message that names one; the office's own
// messages never count, and the task's original message is the oldest. The parsing itself is requestedAppointmentWindow, unchanged.
import { requestedAppointmentWindow, RequestedWindow } from './requestedAppointmentWindow';

export interface ThreadMessage { direction?: string | null; content?: string | null; }

export function requestedWindowFromThread(
  messages: ThreadMessage[] | null | undefined,
  fallbackText: string | null | undefined,
  now: Date = new Date(),
): RequestedWindow | null {
  // The task's original message is the oldest patient message. It is usually
  // the first entry of the thread too, and counting it twice is harmless.
  const texts = [
    String(fallbackText || ''),
    ...(messages || []).filter((m) => m?.direction === 'inbound').map((m) => String(m?.content || '')),
  ].filter((text) => text.trim());
  for (let i = texts.length - 1; i >= 0; i -= 1) {
    const found = requestedAppointmentWindow(texts[i], now);
    if (found) return found;
  }
  return null;
}
